import { GenericService } from "./Generic.service";

export class CareLineService extends GenericService<string>{

    readonly URI: string = 'LinhaCuidado'

    constructor(){
        super()
        this.setUri(this.URI);
    }

    public async getCareLines(){
        return await super.getByResource('', { PageSize: 500 })
    }

    public async getCareLineByName(query: string){
        return await super.getByResource('', { PageSize: 500, Text: query })
    }

    public async registerCareLine(careLine: any){
        return await super.post(careLine)
    }

    public async updateCareLine(careLine: any, careLineId: string){
        return await super.putByResource(careLine, careLineId)
    }
    
    public async activateCareLine(careLineId: string){
        return await super.patchByResource(careLineId, `${careLineId}/Activate`)
    }

    public async inactivateCareLine(careLineId: string){
        return await super.patchByResource(careLineId, `${careLineId}/Inactivate`)
    }
}